<div class="container-full pb-4 criterions-tab distribute-tab"
  *ngIf="criterions?.length; else noCriterions">
  <div class="row">
    <div class="" [ngClass]="{ 'col-md-4' : !viewOnly , 'col-md-6' : viewOnly  }">
      <app-criterions-tree [visitInfo]="visitInfo"
        [userRole]="userRole"
        (changeCriterion)="changeCriterions($event)"
        [criterions]="criterions"></app-criterions-tree>
    </div>
    <div [ngClass]="{ 'col-md-8' : !viewOnly , 'col-md-6' : viewOnly  }">
      <app-team-members *ngIf="selectedCriterion"
        [visitInfo]="visitInfo"
        [userRole]="userRole"
        [selectedMembers]="selectedCriterion.visitMembers"
        (onAdd)="onAdd($event)"
        [viewOnly]="viewOnly"
        [disabled]="disabled"
        (onRemove)="onRemove($event)"></app-team-members>
    </div>
  </div>
</div>

<ng-template #noCriterions>
  <div class="pb-4 criterions-tab distribute-tab text-center">
    <div class="tab-no-data">
      <h4>{{ 'ERRORS.NoDataFound' | translate }}</h4>
    </div>
  </div>
</ng-template>
